<div class="bg-light min-vh-100 d-flex flex-row align-items-center">
  <c-container>
    <c-row class="justify-content-center">
      <c-col md="9">
        <c-card-group>
          <c-card [ngStyle]="{'width.%': 44}" class="py-5">
            <c-card-body>
              <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
                <h1>Forgot Password</h1>
                <p class="text-medium-emphasis">Please use your IIITB email id to get the OTP</p>
                <c-input-group class="mt-3 mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilUser"></svg>
                  </span>
                  <input formControlName="email" autoComplete="email" cFormControl placeholder="Email" (input)="onEmailInput($event)" />
                </c-input-group>

                <c-row>
                  <c-col xs="6">
                    <button [disabled]="forgotPasswordForm.invalid" type="submit" cButton class="px-4" color="primary">
                      Submit
                    </button>
                  </c-col>
                  <c-col class="text-end" xs="6">
                    <button [routerLink]="['/login']" cButton class="px-0" color="link">
                      Back to Login
                    </button>
                  </c-col>
                </c-row>
              </form>
            </c-card-body>

          </c-card>
          <c-card [ngStyle]="{'width.%': 44}" class="text-white bg-primary py-5">
            <c-card-body class="text-center d-flex justify-content-center align-items-center" style="height: 100%;">
              <div class="text-center">
                <img width="150px" height="150px" src="./assets/iiitb_logo.png" alt="IIITB Logo">
                <h2>Welcome to IIIT-B 360<sup>o</sup></h2>
              </div>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>